export default __webpack_public_path__ + "static/media/Meditating_.d0cfdab1.png";